/** Display whole game tokens in millions; never use this to build API/input values. */
export function formatGameMoney(value: number, exact = false): string {
  if (!Number.isFinite(value)) return '—'
  const maximumFractionDigits = exact || Math.abs(value) < 1_000_000 ? 6 : 2
  return `${(value / 1_000_000).toLocaleString('en-US', { maximumFractionDigits })}M`
}
